import { Pipe, PipeTransform } from '@angular/core';
import { UserStorageService } from '@services/user-local-storage.service';

@Pipe({
  name: 'isCurrentUser',
})
export class IsCurrentUserPipe implements PipeTransform {
  constructor(private readonly userStorageService: UserStorageService) {}

  transform(userId: string): boolean {
    return userId === this.userStorageService.userId;
  }
}
